/**
 * Overridden: (original file : themes/answers-hitchhiker-theme/static/js/hours/open-status/messagefactory.js)
 * line 44,66 update return templates based on availability of nextDate for community bankers location type
 */
import HoursStringsLocalizer from '../stringslocalizer.js';
import { OpenStatusStrings, OpenStatusTypes } from './constants.js';

/**
 * Responsible for forming a localized open status message based on the hours data
 * and locale information provided.
 */
export default class OpenStatusMessageFactory {
  constructor(localizer) {
    /**
     * @type {HoursStringsLocalizer}
     */
    this._localizer = localizer;
  }

  /**
   * Creates a localized hours message
   *
   * @param {Object} hoursToday
   * @returns {string}
   */
  create(hoursToday) {
    let time, day, date;
    switch (hoursToday.status) {
      case OpenStatusTypes.OPEN_24_HOURS:
        return `
              <span class="Hours-statusText Hours-open24Hours">
                ${this._localizer.getTranslation(OpenStatusStrings.OPEN_24_HOURS)}
              </span>`;
      case OpenStatusTypes.OPENS_TODAY:
        time = this._localizer.getLocalizedTime(hoursToday.nextTime);
        return `
              <span class="Hours-statusText Hours-opensToday">
                <span class="Hours-statusText--current Hours-closed">
                  ${this._localizer.getTranslation(OpenStatusStrings.CLOSED)}
                </span> · ${this._localizer.getTranslation(OpenStatusStrings.OPENS_AT)} <span class="HoursInterval-time Hours-opensAtTime">
                  ${time}
                </span>
              </span>`;
      case OpenStatusTypes.OPENS_NEXT:
        time = hoursToday.nextTime
          ? hoursToday.nextDate
            ? this._localizer.getLocalizedTime(
                hoursToday.nextTime.replace(":", "")
              )
            : this._localizer.getLocalizedTime(hoursToday.nextTime)
          : '';

        day = hoursToday.nextDay ? this._localizer.getTranslation(
          hoursToday.nextDay
        ) : '';
        date = hoursToday.nextDate;
        return `
              <span class="Hours-statusText Hours-opensNext">
                <span class="Hours-statusText--current Hours-closed">
                ${this._localizer.getTranslation(OpenStatusStrings.CLOSED)}
                </span> 
                ${
                  time
                    ? date ? " - " +
                      this._localizer.getTranslation(
                        OpenStatusStrings.NEXT_OPENS_AT
                      )
                    : " . " +
                      this._localizer.getTranslation(OpenStatusStrings.OPENS_AT) : ""
                }
              </span>
              <span class="HoursInterval-time Hours-opensAtTime">
                ${time}
              </span>
              <span class="HoursInterval-day Hours-opensAtDay">
                ${day}
              </span>
              ${
                date && date.day && date.month
                  ? `<span class="HoursInterval-day Hours-opensAtDate">${date.day} ${date.month}</span>`
                  : ""
              }`;
      case OpenStatusTypes.CLOSES_TODAY:
        time = hoursToday.nextDate ? this._localizer.getLocalizedTime(hoursToday.nextTime.replace(":", "")) : this._localizer.getLocalizedTime(hoursToday.nextTime);
        return `
              <span class="Hours-statusText Hours-closesToday">
                <span class="Hours-statusText--current Hours-openNow">
                  ${this._localizer.getTranslation(OpenStatusStrings.OPEN_NOW)}
                </span> · ${this._localizer.getTranslation(OpenStatusStrings.CLOSES_AT)}
              </span>
              <span class="HoursInterval-time Hours-opensAtTime">
                ${time}
              </span>`;
      case OpenStatusTypes.CLOSES_NEXT:
        time = this._localizer.getLocalizedTime(hoursToday.nextTime);
        day = this._localizer.getTranslation(hoursToday.nextDay);
        return `
              <span class="Hours-statusText Hours-closesNext">
                <span class="Hours-statusText--current Hours-openNow">
                ${this._localizer.getTranslation(OpenStatusStrings.OPEN_NOW)}
                </span> · ${this._localizer.getTranslation(OpenStatusStrings.CLOSES_AT)}
              </span>
              <span class="HoursInterval-time Hours-opensAtTime">
                ${time}
              </span>
              <span class="HoursInterval-day Hours-opensAtDay">
                ${day}
              </span>`;
      case OpenStatusTypes.CLOSED:
        return `
              <span class="Hours-statusText Hours-closed">
                ${this._localizer.getTranslation(OpenStatusStrings.CLOSED)}
              </span>`;
      default:
        return '';
    }
  }
}